<div class="container-icon">
  <i class="fas fa-ban iconFa" id="noAccessIcon"></i>
  <p class="p"> NO TIENES ACCESO </p>
</div>

<div class="container">
    <mat-card appearance="outlined" class="mat-elevation-z3 m-4" style="background-color: #ffffff7a;">
      <mat-card-content class="mat-body-1">
        <div class="p-2">
          <p class="p1" >Lo sentimos. No tienes acceso a este módulo con tu plan actual </p>
          <p class="p1">¡Actualiza tu plan hoy mismo aquí!</p>
        </div>
        <div class="d-flex flex-wrap col-12 p-3">
          <p class="p2 col-sm-12 col-12">Módulo: {{moduleName}}</p>
          <p class="p2 col-sm-12 col-12"><a href ="URL"></a></p>      
          <p class="p2 col-sm-12 col-12" > <i class="fa fa-phone"></i> Contacto: +57 3124543070</p>      
          <p class="p2 col-sm-12 col-12"> <i class="fa fa-phone"></i> Contacto: +57 3182576253</p>
        </div>     
      </mat-card-content>
    </mat-card>

    
  </div>
